/* ================================================== */
/* OBJECT FIT IMAGES
/* ================================================== */

// Init
$(function() {
	objectFitImages();
});